export const GATEWAYS = {
    ADD_ACH_PROCESSING: "add-ach-button",
    ADD_ACH_PROCESSING_WITH_TOOLTIP: "add-ach-button-with-tooltip",
    ADD_GATEWAY_PROCESSOR: "add-processor-button",
    ADD_GATEWAY_PROCESSOR_SPINNER: "add-processor-button-spinner",
    GATEWAY_PROCESSOR_SELECTOR: "gateway-selector",
    GATEWAY_PROCESSOR_INPUT: "gateway-input",
    OPTION_POSTFIX: "-option",
    AUTH_MODE_OPTION: "-auth_mode_option",
    AUTH_MODE_SELECTOR: "auth-mode-selector",
    CURRENCY_SELECTOR: "currency-selector",
    CURRENCY_INPUT: "currency-input",
    CURRENCY_POSTFIX: "-option",
    TERMS_CHECKBOX: "terms-checkbox",
    CREATE_ACCOUNT: "create-account-button",
    CREATE_ACH_ACCOUNT: "create-ach-account-button",
    EDIT_ACCOUNT: "edit-account-button",
    DELETE_BUTTON: "delete-btn",
    MODIFY_PSD2_BUTTON: "modify-psd2",
    NOTIFICATION_YES_BUTTON: "notification-yes-button",
    NOTIFICATION_NO_BUTTON: "notification-no-button",
    NOTIFICATION_OK_BUTTON: "ok-button",
    CLOSE_WINDOW_BUTTON: "close-button",
    GATEWAY_OPTIONS: {
        NUORDER_USD: {
            TEST_RAIL_CODE: "C280462",
            GATEWAY: "NuORDER Payments",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                SUBMERCHANT: "gateway-field-account_id",
                INFINICEPT: "gateway-field-infinicept_submerchant_id",
            },
        },
        NUORDER_PSD2: {
            TEST_RAIL_CODE: "C335510",
            GATEWAY: "NuORDER Payments",
            AVAILABLE_CURRENCIES: ["EUR"],
            REQUIRED_FIELDS: {
                SUBMERCHANT: "gateway-field-account_id",
                INFINICEPT: "gateway-field-infinicept_submerchant_id",
            },
            CUSTOM_FIELDS: {
                PSD2_VISA_ACQ_BIN: "psd2-card-visa-acquirerBin",
                PSD2_VISA_MERCH_ID: "psd2-card-visa-acquirerMerchantId",
                PSD2_MASTER_ACQ_BIN: "psd2-card-mastercard-acquirerBin",
                PSD2_MASTER_MERCH_ID: "psd2-card-mastercard-acquirerMerchantId",
                PSD2_AMEX_ACQ_BIN: "psd2-card-amex-acquirerBin",
                PSD2_AMEX_MERCH_ID: "psd2-card-amex-acquirerMerchantId",
                MERCHANT_MCC: "psd2-mcc",
                MERCHANT_NAME: "psd2-merchantName",
                MERCHANT_COUNTRY: "psd2-countryCode",
                MERCHANT_URL: "psd2-merchantUrl",
            },
        },
        SAGE_SOLUTIONS: {
            TEST_RAIL_CODE: "C335402",
            GATEWAY: "Sage Payment Solutions",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                ID: "gateway-field-merchant_id_number",
                KEY: "gateway-field-merchant_key_number",
            },
        },
        AUTHORIZE_NET: {
            TEST_RAIL_CODE: "C335403",
            GATEWAY: "Authorize.Net",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                ID: "gateway-field-login",
                KEY: "gateway-field-password",
            },
        },
        PAYEEZY: {
            TEST_RAIL_CODE: "C335404",
            GATEWAY: "Payeezy",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                KEY: "gateway-field-api_key",
                TOKEN: "gateway-field-api_token",
                SECRET: "gateway-field-api_secret",
            },
        },
        SAGEPAY: {
            TEST_RAIL_CODE: "C335405",
            GATEWAY: "SagePay",
            AVAILABLE_CURRENCIES: ["GBP"],
            REQUIRED_FIELDS: {
                KEY: "gateway-field-login",
            },
        },
        BAMBORA: {
            TEST_RAIL_CODE: "C335406",
            GATEWAY: "Bambora (formerly Beanstream)",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                MERCHANT_ID: "gateway-field-merchant_id",
                USERNAME: "gateway-field-username",
                PASSWORD: "gateway-field-password",
                KEY: "gateway-field-api_key",
            },
        },
        WORLDPAY: {
            TEST_RAIL_CODE: "C335407",
            GATEWAY: "Worldpay US",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                ACCOUNT_ID: "gateway-field-acctid",
                SUBMERCHANT_ID: "gateway-field-subid",
                MERCHANT_PIN: "gateway-field-merchantpin",
            },
        },
        ORBITAL: {
            TEST_RAIL_CODE: "C335408",
            GATEWAY: "Orbital (Chase Paymentech)",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                MERCHANT_ID: "gateway-field-merchant_id",
            },
        },
        CYBER: {
            TEST_RAIL_CODE: "C335409",
            GATEWAY: "CyberSource",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                USER_NAME: "gateway-field-user_name",
                TRANSACTION_KEY: "gateway-field-transaction_key",
            },
        },
        PAYPAL: {
            TEST_RAIL_CODE: "C335410",
            GATEWAY: "PayPal",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                LOGIN: "gateway-field-login",
                PASSWORD: "gateway-field-password",
                SIGNATURE: "gateway-field-signature",
            },
        },
        BRAINTREE: {
            TEST_RAIL_CODE: "C335411",
            GATEWAY: "Braintree",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                LOGIN: "gateway-field-login",
                PASSWORD: "gateway-field-password",
            },
        },
        WINDCAVE: {
            TEST_RAIL_CODE: "C335412",
            GATEWAY: "Windcave",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                LOGIN: "gateway-field-login",
                PASSWORD: "gateway-field-password",
            },
        },
        ADYEN: {
            TEST_RAIL_CODE: "C335413",
            GATEWAY: "Adyen",
            AVAILABLE_CURRENCIES: ["USD"],
            REQUIRED_FIELDS: {
                USERNAME: "gateway-field-username",
                PASSWORD: "gateway-field-password",
                MERCHANT_ACCOUNT: "gateway-field-merchant_account",
            },
        },
        LIGHTSPEED_PAYMENTS: {
            TEST_RAIL_CODE: "C?????",
            GATEWAY: "Lightspeed Payments",
            AVAILABLE_CURRENCIES: ["CAD"],
            REQUIRED_FIELDS: {
                PASSWORD: "gateway-field-password",
            },
        },
    },
};
